
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training",
      function () {
        return require("private-next-pages/training/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training"])
      });
    }
  